import Vue from 'vue';
import VueI18n from 'vue-i18n';
import App from './App.vue';
import store from './store';
import router from './router';
import Axios from 'axios';
import BootstrapVue from "bootstrap-vue";
import 'vue-material-design-icons/styles.css';
import { TreeViewPlugin } from "@syncfusion/ej2-vue-navigations";
import { i18n } from './plugins/i18n'
import { Trans } from './plugins/Translation'
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';
import { SlickList, SlickItem } from 'vue-slicksort';
import bConfig from './config/b-config';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import api from "./config/api";
import DateFilter from './filter/date-filter'
import vSelect from 'vue-select'
import SocialSharing from 'vue-social-sharing'
import VueMeta from 'vue-meta'
import Vuelidate from "vuelidate";
import VuelidateErrorExtractor, { templates } from "vuelidate-error-extractor";
import VueMask from 'v-mask';
import Adsense from "vue-google-adsense/dist/Adsense.min.js";
import getEnv from '@/utils/env'
import vueDebounce from 'vue-debounce'
import Viewer from 'v-viewer'
import Inview from 'vueinview'

import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import GmapCircle from 'vue2-google-maps/dist/components/circle'
import { Sketch } from 'vue-color'
import { mapActions, mapGetters, mapMutations } from 'vuex';
import io from 'socket.io-client';
import mgr from './security/security';

const globalData = {
  isAuthenticated: false,
  user: '',
  mgr: mgr,
  loading: true,
  socket: null
}
import 'splitpanes/dist/splitpanes.css'
globalData.loading = true;
const globalMethods = {
  async authenticate(returnPath) {
    const user = await this.$root.getUser();
    if (!!user) {
      this.isAuthenticated = true;
      this.user = user;
    } else if (returnPath) {
      await this.$root.signIn(returnPath);
    }
  },
  async getUser() {
    try {
      let mgr = await this.mgr();
      let user = await mgr.getUser();
      return user;
    } catch (err) {

    }
  },
  async signIn(returnPath) {
    this.loading = true;
    let mgr = await this.mgr();
    returnPath ? await mgr.signinRedirect({ state: returnPath })
      : await mgr.signinRedirect();
  },
  async signOut() {
    this.loading = true;
    this.isAuthenticated = false;
    this.user = null;
    let mgr = await this.mgr();
    await mgr.signoutRedirect();
  },
  async renewToken() {
    this.loading = true;
    let mgr = await this.mgr();
    this.user = await mgr.getUser();
    if (!!this.user) {
      this.isAuthenticated = true;
      await mgr.signinSilent();
      const user = await mgr.getUser();
      this.user = user;
    }
  },
  initSocket(){
    let _this=this;
    console.log("_this",_this)
    console.log("getEnv('VUE_APP_API_URL')",getEnv('VUE_APP_API_URL'));
    if(_this.user.access_token){
      this.socket = io.connect(getEnv('VUE_APP_API_URL'), {
        forceNew: true,
        query: { token:_this.user.access_token }
      });
      console.log("this.$root.socket initSocket",this.socket)

      this.socket.on('chat-message', function(data) {
        data.admin=false;
        _this.SET_UNREAD_MESSAGE(_this.unreadMessages+1);
        _this.$emit('chat-message',data)
      })
      this.socket.on('chat-message-admin', function(data) {
        data.admin=true;
        _this.SET_UNREAD_MESSAGE(_this.unreadMessages+1);
        _this.$emit('chat-messages-admin',data)
      })
      this.socket.on('connect', function() {
      });
      this.socket.on('connecting', function() {
      });
      this.socket.on('disconnect', function() {
      });
    }
  },
}


// Vue.loadScript("/assets/file-upload/font/font-fileuploader.css")
// Vue.loadScript("/assets/file-upload/jquery.fileuploader.min.css")
// Vue.loadScript("/assets/file-upload/jquery.fileuploader.min.js")

global.axios = Axios
Axios.defaults.baseURL = getEnv('VUE_APP_API_URL')

Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)
Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(VuelidateErrorExtractor, {
  i18n: false,
  // Define common validation messages.
  messages: {
    required: "{attribute} is required!",
    isJoe: "{attribute} must be Joe",
    notGmail: "{attribute} must not be gmail",
    email: "{attribute} is not a valid Email address.",
    isEmailAvailable:
      "{attribute} is not available. Must be at least 10 characters long."
  }
});

Vue.component("form-group", templates.singleErrorExtractor.foundation6);

Vue.use(Inview)
Vue.use(BootstrapVue,bConfig);
Vue.use(TreeViewPlugin);
Vue.use(VueFileAgent);
Vue.use(VueSweetalert2);
Vue.component('vfa-sortable-list', SlickList);
Vue.component('vfa-sortable-item', SlickItem);
Vue.filter('date', DateFilter);
Vue.component('v-select', vSelect);
Vue.use(SocialSharing);
Vue.use(VueMeta, { refreshOnceOnNavigation: true });
Vue.use(VueMask);
Vue.use(vueDebounce)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    "inline": false,
    "button": true,
    "navbar": true,
    "title": true,
    "toolbar": false,
    "tooltip": true,
    "movable": true,
    "zoomable": true,
    "rotatable": true,
    "scalable": true,
    "transition": true,
    "fullscreen": true,
    "keyboard": true,
  }
})


Vue.component('color-picker', Sketch);

//google map

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD8q8f_lSiHhP1za-ybs9vOrE8jc22fBg4',
    v: 3.41,
    libraries: 'places',
    language: Trans.currentLanguage,
  },
  // Demonstrating how we can customize the name of the components
  installComponents: false,
});
VueGoogleMaps.GmapCircle
Vue.component('GmapCluster', GmapCluster)
Vue.component('gmap-circle', GmapCircle)
Vue.component('google-map', VueGoogleMaps.Map);
Vue.component('google-marker', VueGoogleMaps.Marker);
Vue.component('google-autocomplete', VueGoogleMaps.Autocomplete);
Vue.component('google-info-window', VueGoogleMaps.InfoWindow);
  Vue.component('ground-overlay', VueGoogleMaps.MapElementFactory({
    mappedProps: {
      'opacity': {}
    },
    props: {
      'source': {type: String},
      'bounds': {type: Object},
    },
    events: ['click', 'dblclick','mousedown','mousemove','mouseup'],
    name: 'groundOverlay',
    ctr: () => window.google.maps.GroundOverlay,
    ctrArgs: (options, {source, bounds}) => [source, bounds, options],
  }));



// api.get(
//   '/categories'
// )
// .then(function (response) {
//   Vue.prototype.$categories = response.data
// })
// .catch(function (error) {
  
// });
Vue.prototype.$domain = () => {
  var domain = window.location.origin;
  if (domain.endsWith("/")) {
    domain = domain.substring(0, domain.length - 1);
  }
  return domain
}
var filter = function (text, length, clamp) {
  clamp = clamp || '...';
  var node = document.createElement('span');
  node.innerHTML = text;
  var content = node.textContent;
  var a = text.length > length ? text.slice(0, length) + clamp : text;
  return a;
};
Vue.filter('truncate', filter);

let main = new Vue({
  el: "#app",
  router,
  data: globalData,
  store,
  i18n,
  render: h => h(App),
  async mounted() { 
    Vue.use(require('./assets/file-upload/jquery.fileuploader.min.js'));
    Vue.use(require('vue2-animate/dist/vue2-animate.min.css'));
    Vue.use(require("vue-script2"));
    Vue.use(Adsense);
    this.getProjectConfig();
    await this.renewToken();
    document.dispatchEvent(new Event("render-event"));
    //google ads vue script
   
    
  },
  computed:{
		...mapGetters('ChatController', ['unreadMessages']),
	},
  methods: {
    ...mapMutations("ChatController", ['SET_UNREAD_MESSAGE']),
    ...mapActions("SiteConfigController", [
      "GET_PROJECT_CONFIG"
    ]),
    ...globalMethods,
    getProjectConfig() {
      this.GET_PROJECT_CONFIG().then((result) => {
        // Load style for Header and footer
        let headerStyle = document.createElement('link');
				headerStyle.rel = 'stylesheet';
				headerStyle.href = result.header_style;
        document.head.appendChild(headerStyle);
        let footerStyle = document.createElement('link');
				footerStyle.rel = 'stylesheet';
				footerStyle.href = result.footer_style;
        document.head.appendChild(footerStyle);
        
        this.$root.siteTitle = result.home_title;
        this.$forceUpdate();
        this.$root.loadingImage = result.loading_icon_url;
        this.$root.siteTitle_subTitle = result.home_subtitle;
        this.$root.category_color_residence = result.category_color_residence;
        this.$root.category_color_commercial = result.category_color_commercial;
        this.$root.category_color_land = result.category_color_land;
        this.$root.category_color_newproject = result.category_color_newproject;
        this.$root.primary_color = result.primary_color;
        document.documentElement.style.setProperty('--projectPrimaryColor', result.primary_color);
        document.querySelector(':root').style.setProperty('--projectPrimaryColor', result.primary_color);
        document.querySelector(':root').style.setProperty('--primary', result.primary_color);
        document.querySelector(':root').style.setProperty('--deleteButtonBgColor', result.cancel_button_color);
        document.documentElement.style.setProperty('--borderRadius', result.radio_button + 'px');
        document.querySelector(':root').style.setProperty('--seukhaiMainLighterColor',this.convertHexToRGBA(this.$root.primary_color, 20));
        
        setTimeout(()=>{
          this.$root.loading = false;
        },2000)
        console.log("$root.loadingImage",this.$root.loadingImage)
      });
    },
    convertHexToRGBA(hexCode, opacity) {
			let hex = hexCode.replace('#', '');

			if (hex.length === 3) {
				hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
			}

			const r = parseInt(hex.substring(0, 2), 16);
			const g = parseInt(hex.substring(2, 4), 16);
			const b = parseInt(hex.substring(4, 6), 16);

			return `rgba(${r},${g},${b},${opacity / 100})`;
		}
  },
});


router.beforeEach((to, from, next) => {
  if (to.name.match(/User/) || to.name.match(/Admin/) || to.name.match(/Search/)) {
    // main.loading = false;
  } else {
    // main.loading = true;
  }
  next();
});


api.interceptors.request.use(
  async config => {
    if (!main.$root.user && config.url !== '/site-configs/auth-config') {
      await main.$root.authenticate();
    }
    if (main.$root.user && main.$root.user.access_token) {
      config.headers.Authorization = `Bearer ${main.$root.user.access_token}`;
    }
    config.headers['Accept-Language'] = Trans.currentLanguage;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
api.interceptors.response.use(
  response => {
    if (response.status === 200 || response.status === 201) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        case 400:
          break;
        case 401:
          main.$root.signIn();
          break;
        case 403:
           break;
        case 404:
          window.location('/404')
          break;
        case 502:
          break;
      }
      return Promise.reject(error.response);
    }
  }
);
